
import { BASE_URL } from "../../helpers/config";
import { showToast, showAlert } from "../../utils/helpers/ShowToast";
import { getReadableApiError } from "../../utils/helpers/apiError";
import authorizedAxios from "../../helpers/authorizedAxios";
export const SET_CUSTOMERS = "SET_CUSTOMERS";
export const SET_CUSTOMERS_LOADING = "SET_CUSTOMERS_LOADING";
export const SET_CUSTOMERS_ERROR = "SET_CUSTOMERS_ERROR";

export const fetchPublicCustomers = (limit = 100, page = 1, search = "") => {
  return async (dispatch) => {
    dispatch({ type: SET_CUSTOMERS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get(
        "/public/customers?limit=" + limit + "&page=" + page + "&search=" + search
      );

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_CUSTOMERS,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_CUSTOMERS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_CUSTOMERS_LOADING, status: false });
    }
  };
};

export const fetchCustomers = (limit = 100, page = 1, search = "") => {
  return async (dispatch) => {
    dispatch({ type: SET_CUSTOMERS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/customers?limit=" + limit + "&page=" + page + "&search=" + search);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_CUSTOMERS,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_CUSTOMERS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_CUSTOMERS_LOADING, status: false });
    }
  };
};

export const getCustomerById = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_CUSTOMERS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/customers/" + id);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_CUSTOMERS,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_CUSTOMERS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_CUSTOMERS_LOADING, status: false });
    }
  };
};

export const addCustomer = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_CUSTOMERS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post(`${BASE_URL}/customers`, data), {
        loading: "Menyimpan data...",
        success: "Data pelanggan berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data!"
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchCustomers());
        return response?.data?.data || true;
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_CUSTOMERS_ERROR,
        error: getReadableApiError(error, "Data pelanggan gagal disimpan.")
      });
      return false;
    } finally {
      dispatch({ type: SET_CUSTOMERS_LOADING, status: false });
    }
  };
};

export const updateCustomer = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_CUSTOMERS_LOADING, status: true });
    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/customers/${id}`, data), {
        loading: "Mengupdate data...",
        success: "Data pelanggan berhasil diupdate!",
        error: (err) => err?.response?.data?.message || "Gagal mengupdate data!"
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchCustomers());
        return true;
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_CUSTOMERS_ERROR,
        error: getReadableApiError(error, "Data pelanggan gagal diperbarui.")
      });
      return false;
    } finally {
      dispatch({ type: SET_CUSTOMERS_LOADING, status: false });
    }
  };
};

export const deleteCustomer = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_CUSTOMERS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.delete(`${BASE_URL}/customers/${id}`), {
        loading: "Menghapus data...",
        success: "Data pelanggan berhasil dihapus!",
        error: (err) => err?.response?.data?.message || "Gagal menghapus data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data pelanggan berhasil dihapus!"
        });
        dispatch(fetchCustomers());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_CUSTOMERS_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
    } finally {
      dispatch({ type: SET_CUSTOMERS_LOADING, status: false });
    }
  };
};
